import { useEffect, useState } from 'react'
import { useWebRegisterStatusManager } from '../../ng-compat/hooks'
import { EVENTS } from '../../constants/status'

export const useIsOffline = () => {
  const webRegisterStatusManager = useWebRegisterStatusManager()
  const [isOffline, setIsOffline] = useState(
    !webRegisterStatusManager.isOnline()
  )

  useEffect(() => {
    const transitionOnline = () => setIsOffline(false)
    const transitionOffline = () => setIsOffline(true)
    webRegisterStatusManager.on(EVENTS.transitionOnline, transitionOnline)
    webRegisterStatusManager.on(EVENTS.transitionOffline, transitionOffline)

    return () => {
      webRegisterStatusManager.off(EVENTS.transitionOnline, transitionOnline)
      webRegisterStatusManager.off(EVENTS.transitionOffline, transitionOffline)
    }
  }, [webRegisterStatusManager])

  return { isOffline }
}
